/*
 * append the leadsource to the iframe URL
 */
(function () {

	"use strict";

	var iframe, matches;

	if (window.location.search) {

		matches = window.location.search.match(/leadsource=(\d+)([;&#]|$)/);
		if (matches) {

			iframe = document.querySelector("iframe[name=salesforce]");
			if (iframe && !iframe.src.match(/\?/)) {

				iframe.src += "?leadsource=" + matches[1];

			}

		}

	}

}());
